import "./footer.css";
import { useContext, useState } from "react";
import { AppContext } from "../contextApi/ContextApi";
import { useNavigate } from "react-router-dom";

export default function Footer({ isDashboard, setDisplay, navRef, navbarArr }) {
    const {currentWebsite, accent_color, secondary_color, primary_color, hasCategories, hasBranches, hasHelpdesk, hasJobs, hasAbout, setCategoryNow} = useContext(AppContext);

    const [hasNavbar] = useState(hasCategories||hasBranches||hasJobs||hasHelpdesk);
    const [filteredNav] = useState(()=>{
        return navbarArr?.filter((val)=>{
            return val.include;
        }) || [];
    });
    const dataLists = {
        main: {
            list:[
                {title:"עמוד הבית", link:"home"},
                hasAbout && {title:"אודות", link:"about"},
                hasHelpdesk && {title:"צור קשר", link:"helpdesk"},
                hasJobs && {title:"דרושים", link:"our_jobs"},
            ],
            _id:"mainList"
        },
        categories:{
            list:currentWebsite.settings.categories.map((c)=>{return {...c, title:c.name, link:"products"}}),
            _id:"categoriesList"
        },
        branches:{
            list:currentWebsite.settings.branches.map((b)=>{return {...b, title:`${b.city}, ${b.address}`, link:"our_branches"}}),
            _id:"branchesList"
        }
    }
    const nav = useNavigate();
    const handleChangeDisplay=(val)=>{
        navRef.current.scrollIntoView({
            behavior:"smooth"
        })
        if(val.link === "products"){setCategoryNow(val)}
        return isDashboard ? setDisplay(`/${val.link}`) : !isDashboard && val.link!==null ? nav(`/${currentWebsite?.settings?.domain}/${val.link}`) : null;
    }
    const deployMain=(parameter)=>{
        if(parameter?.list?.length===0){
            return <p key={`footer_main_empty_${parameter?._id}`} className="footer_list_p">קטגוריה זו ריקה.</p>
        }
        return parameter?.list?.map((item, inx)=>{
            if(inx===6){
                return <p key={`footer_main_${inx}`} className="footer_list_p" onClick={()=>{handleChangeDisplay(item)}}>עוד...</p>
            }
            else if(inx > 6) return;
            return <p key={`footer_main_${inx}`} className="footer_list_p" onClick={()=>{handleChangeDisplay(item)}}>{item.title}</p>
        })   
    }

  return (
    <div dir='rtl' style={{backgroundColor:primary_color, color:accent_color, borderTop:accent_color, textShadow:`1px 1px 2px ${secondary_color}`, height:"50vh", width:"100%", display:!hasNavbar&&filteredNav.length===0 ? "none" : "grid", gridTemplateColumns:hasCategories&&hasBranches ? "1fr 1fr 1fr" : hasBranches||hasCategories ? "1fr 1fr" : "1fr", margin:"40px auto 0"}}>
        <div className='footer_main'>
            <h4>מידע כללי</h4>
            {deployMain(dataLists.main)}
        </div>
        {hasCategories ? <div className='footer_products'>
            <h4>המוצרים שלנו</h4>
            {deployMain(dataLists.categories)}
        </div> : null}
        {hasBranches ? <div className='footer_branches'>
            <h4>רשימת הסניפים שלנו</h4>
            {deployMain(dataLists.branches)}
        </div> : null}
    </div>
  )
}
